import { RootInitialState } from 'core/common/store';

export const getFunnelName = (state: RootInitialState) => {
  const config = state.funnelConfig.config;

  if (config) {
    return config.name;
  }

  return '';
};
